<template>
  <div>
    <div id="goz_esnetme22">
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>

      <div id="true" style="display: none; position: absolute; top: 133px">
        <i class="fas fa-check" style="font-size: 40px; color: green"></i>
      </div>
      <div id="false" style="display: none; position: absolute; top: 133px">
        <i class="fas fa-times" style="font-size: 40px; color: red"></i>
      </div>

      <div
        style="
          background-color: #fff;
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          z-index: 91369192;
        "
        v-if="finished"
      >
        <div>{{ $t("module.point") }}: {{ point }}</div>
        <div>{{ $t("module.total_true") }}: {{ totalTrue }}</div>
        <div>{{ $t("module.total_false") }} {{ totalFalse }}</div>
        <div>
          {{ $t("module.isabet") }}
          {{ ((totalTrue / (totalTrue + totalFalse)) * 100).toFixed(1) }}%
        </div>
        <div>
          {{ $t("module.reaction") }}
          {{
            (
              reactions.reduce((i, y) => i + y, 0) /
              reactions.length /
              1000
            ).toFixed(2)
          }}
          {{ $t("module.seconds") }}
        </div>
        <el-button round type="primary" class="mt-3" @click="init">
          {{ $t("module.start_again") }}
        </el-button>
      </div>

      <h3
        style="
          position: absolute;
          top: 50px;
          font-size: 27px;
          text-align: center;
        "
      >
        {{ !wordMode ? $t("hizli_triple_shape") : $t("hizli_triple_word") }}
      </h3>

      <div
        v-if="started"
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          background-color: rgb(255 162 14);
          padding: 5px 0px;
        "
      >
        <div
          style="
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
            color: white;
          "
        >
          <strong class="text-white">{{ $t("module.time") }}</strong
          >: 00:{{ counter }}
        </div>
        <div
          style="
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
            color: white;
          "
        >
          <strong class="text-white">{{ $t("module.point") }}</strong
          >: {{ point }}
        </div>
        <div
          style="
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
            color: white;
          "
        >
          <strong class="text-white">{{ $t("module.level") }}</strong
          >: {{ level }}
        </div>
      </div>

      <div
        v-if="started == false"
        style="
          background-color: rgb(28, 68, 156);
          position: absolute;
          width: 100px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 99;
          border-radius: 20px;
          text-align: center;
          color: white;
          box-shadow: rgb(28 68 156) 0px 0px 15px;
          font-weight: bold;
          font-size: 22px;
          cursor: pointer;
          top: 133px;
        "
        @click="start"
      >
        {{ startCounter == 0 ? $t("module.start") : startCounter }}
      </div>

      <div style="width: 90%; position: absolute; top: 200px">
        <transition-group
          name="list-complete"
          tag="p"
          style="
            width: 100%;
            overflow: hidden;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div
            class="flip-card list-complete-item"
            :class="i.picked === true ? 'picked' : ''"
            v-for="(i, index) in currentStack"
            :key="i.id"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div
              class="flip-card-inner"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div
                v-if="!wordMode"
                class="flip-card-front"
                v-html="i.shape.url.replace('[color]', i.color)"
              ></div>
              <div
                :style="{ padding: wordMode ? '0px' : '40px' }"
                v-if="wordMode"
                style="line-height: 190px; font-size: 38px"
                class="flip-card-front"
              >
                {{ i.word }}
              </div>
              <div class="flip-card-back"></div>
            </div>
          </div>
        </transition-group>
      </div>

      <div style="position: absolute; bottom: 20px">
        <a
          href="javascript:;"
          style="
            padding: 10px 15px;
            border-radius: 10px;
            color: black;
            font-size: 19px;
          "
          @click="check({ keyCode: 37 })"
        >
          <span
            style="
              border: 1px solid #000;
              width: 30px;
              display: inline-block;
              text-align: center;
              margin-right: 5px;
            "
          >
            <i class="fas fa-long-arrow-alt-left"></i>
          </span>
          <span>Yok</span>
        </a>

        <a
          href="javascript:;"
          style="
            padding: 10px 15px;
            border-radius: 10px;
            color: black;
            font-size: 19px;
          "
          @click="check({ keyCode: 39 })"
        >
          <span>Var</span>
          <span
            style="
              border: 1px solid #000;
              width: 30px;
              display: inline-block;
              text-align: center;
              margin-right: 5px;
            "
          >
            <i class="fas fa-long-arrow-alt-right"></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import moment from "moment";
import axios from "axios";
import w from "./level1";
export default {
  name: "HizliSecim",
  props: ["config"],
  data() {
    return {
      currentCardIndex: 199,
      words: w.split(","),
      shapes: [
        {
          key: "circle",
          url: `<svg width="512px" height="512px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="[color]" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"/></svg>`,
        },
        {
          key: "drop",
          url: `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="196.096px" height="196.096px" viewBox="0 0 196.096 196.096" style="enable-background:new 0 0 196.096 196.096;"	 xml:space="preserve"><g>	<g>		<path fill="[color]" d="M96.103,0.799c-3.025,3.166-74.198,77.98-74.198,119.158c0,41.99,34.156,76.139,76.143,76.139			c42.001,0,76.143-34.153,76.143-76.139c0-41.178-71.171-115.993-74.198-119.158C98.972-0.267,97.114-0.267,96.103,0.799z"/>	</g></g></svg>`,
        },
        {
          key: "polygon",
          url: `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve"><path fill="[color]" d="M59.662,26.042L30.701,0.458c-0.377-0.332-0.94-0.334-1.319-0.004L0.343,25.79c-0.306,0.267-0.42,0.692-0.289,1.076	l11,32.249c0.138,0.405,0.519,0.677,0.946,0.677h35.954c0.427,0,0.806-0.271,0.945-0.674l11.046-32	C60.077,26.735,59.966,26.311,59.662,26.042z"/><g></svg>`,
        },
        {
          key: "square",
          url: `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 455 455" style="enable-background:new 0 0 455 455;" xml:space="preserve"><rect fill="[color]" width="455" height="455"/></svg>`,
        },
        {
          key: "star",
          url: `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 55.867 55.867" style="enable-background:new 0 0 55.867 55.867;" xml:space="preserve"><path fill="[color]" d="M55.818,21.578c-0.118-0.362-0.431-0.626-0.808-0.681L36.92,18.268L28.83,1.876c-0.168-0.342-0.516-0.558-0.896-0.558	s-0.729,0.216-0.896,0.558l-8.091,16.393l-18.09,2.629c-0.377,0.055-0.689,0.318-0.808,0.681c-0.117,0.361-0.02,0.759,0.253,1.024	l13.091,12.76l-3.091,18.018c-0.064,0.375,0.09,0.754,0.397,0.978c0.309,0.226,0.718,0.255,1.053,0.076l16.182-8.506l16.18,8.506	c0.146,0.077,0.307,0.115,0.466,0.115c0.207,0,0.413-0.064,0.588-0.191c0.308-0.224,0.462-0.603,0.397-0.978l-3.09-18.017	l13.091-12.761C55.838,22.336,55.936,21.939,55.818,21.578z"/></svg>`,
        },
        {
          key: "tag",
          url: `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="31px" height="31px" viewBox="0 0 31 31" style="enable-background:new 0 0 31 31;" xml:space="preserve"><g>	<path fill="[color]" d="M31,15.5c0,1.202-0.469,2.333-1.318,3.182l-1.904,1.904v2.691c0,2.48-2.019,4.5-4.498,4.5h-2.692l-1.903,1.904		C17.833,30.531,16.703,31,15.5,31s-2.333-0.469-3.184-1.32l-1.901-1.899H7.723c-1.203,0-2.332-0.47-3.183-1.318		c-0.851-0.853-1.317-1.979-1.317-3.182v-2.694l-1.904-1.902C0.469,17.833,0,16.702,0,15.5s0.469-2.333,1.318-3.182l1.904-1.903		V7.724c0-2.481,2.019-4.5,4.498-4.5h2.692l1.905-1.905C13.167,0.469,14.297,0,15.5,0s2.333,0.469,3.184,1.32l1.901,1.901h2.692		c1.201,0,2.332,0.468,3.182,1.317c0.852,0.852,1.318,1.981,1.318,3.183v2.692l1.904,1.904C30.531,13.167,31,14.298,31,15.5z"/></g></svg>`,
        },
      ],
      colors: ["purple", "red", "pink", "yellow", "blue", "orange"],
      stack: [],
      level: 1,
      counter: 10,
      reactions: [],
      lastPickTime: new Date().getTime(),
      trueStack: 0,
      started: false,
      startCounter: 0,
      startInterval: null,
      point: 0,
      totalTrue: 0,
      totalFalse: 0,
      pause: false,
      finished: false,
      currentStack: [],
      wordMode: true,
    };
  },
  created() {
    this.init();
    if (this.config != undefined && this.config != null) {
      this.$root.$emit("pause", true);
    }
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme22").clientWidth,
      height: document.getElementById("goz_esnetme22").clientHeight,
    };

    window.addEventListener("keydown", this.check);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    window.removeEventListener("keydown", this.check);
  },
  methods: {
    init() {
      $(".flip-card").css("z-index", "unset");
      if (
        this.config != null &&
        this.config != undefined &&
        this.config.getTime() < 60
      ) {
        this.$root.$emit("done", true);
        return;
      }
      this.lock = false;
      this.finished = false;
      this.started = false;
      this.counter = 60;
      this.reactions = [];
      this.level = 1;
      this.totalTrue = 0;
      this.totalFalse = 0;
      this.point = 0;
      this.currentCardIndex = 199;
      this.stack = [];
      this.currentStack = [];
      var same = 0;
      var sameCounter = 0;
      for (let index = 0; index < 200; index++) {
        var colorIndex = _.random(0, this.colors.length - 1);
        var shapeIndex = _.random(0, this.shapes.length - 1);
        this.stack.push({
          color: this.colors[colorIndex],
          shape: this.shapes[shapeIndex],
          id: _.random(0, 581239322),
          picked: false,
          word: this.words[_.random(0, this.words.length - 1)],
        });
      }

      for (let index = 0; index < 3; index++) {
        this.currentStack.push({
          ...this.stack[0],
          picked: false,
        });
        this.stack.splice(0, 1);
      }
    },
    start() {
      this.startCounter = 3;
      this.startInterval = setInterval(() => {
        this.startCounter -= 1;
        if (this.startCounter == 0) {
          clearInterval(this.startInterval);
          this.started = true;
          this.currentStack[0].picked = true;
          this.currentStack[1].picked = true;
          this.start2();
        }
      }, 1000);
    },
    start2() {
      setTimeout(() => {
        this.$root.$emit("pause", false);
      }, 2000);
      this.currentCardIndex -= 1;
      this.lastPickTime = new Date().getTime();
      this.interval = setInterval(() => {
        this.counter -= 1;
        if (this.counter == 0) {
          this.$root.$emit("pause", true);
          axios.post("module/savePoints", {
            points: [
              {
                point: this.point,
                type: "dikkat",
              },
            ],
            module_id: this.$store.state.modules.find(
              (k) => k.slug == "hizli-secim"
            ).module_id,
          });

          axios.post("module/savePoints", {
            points: [
              {
                point:
                  this.reactions.reduce(
                    (counter, item) => (item += counter),
                    0
                  ) / this.reactions.length,
                type: "tepki",
              },
            ],
            module_id: this.$store.state.modules.find(
              (k) => k.slug == "hizli-secim"
            ).module_id,
          });

          clearInterval(this.interval);
          this.finished = true;
        }
      }, 1000);
    },
    check(e) {
      if (this.started == false || this.lock || this.finished) return;
      this.lock = true;
      const keyCode = parseInt(e.keyCode || e.code || e.keyIdentifier);
      var card = JSON.parse(JSON.stringify(this.currentStack[2]));
      var prevCards = JSON.parse(
        JSON.stringify([this.currentStack[0], this.currentStack[1]])
      );

      if (this.wordMode === false) {
        var varmi = prevCards.some(
          (k) => k.color == card.color && k.shape == card.shape
        );
      } else {
        var varmi = prevCards.some((k) => k.word == card.word);
      }

      switch (keyCode) {
        case 37:
          if (!varmi) {
            this.totalTrue += 1;
            this.point += this.level * 50;
            this.trueStack += 1;
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/correct.mp3").play();
            this.reactions.push(new Date().getTime() - this.lastPickTime);
            this.lastPickTime = new Date().getTime();
          } else {
            this.totalFalse += 1;
            if (this.trueStack == 0) {
              this.level = Math.max(this.level - 1, 1);
            } else {
              this.trueStack -= 1;
            }
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/incorrect.mp3").play();
          }

          var ayni = _.random(0, 1) === 1;

          if (ayni) {
            this.currentStack.push({
              ...this.currentStack[_.random(0, 1)],
              id: _.random(68969949844),
              picked: false,
            });
            this.currentStack.splice(0, 1);
          } else {
            this.currentStack.splice(0, 1);
            this.currentStack.push(this.stack[0]);
          }

          this.currentStack[1].picked = true;
          this.stack.splice(0, 1);

          break;

        case 39:
          if (varmi) {
            this.totalTrue += 1;
            this.point += this.level * 50;
            this.trueStack += 1;
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/correct.mp3").play();
            this.reactions.push(new Date().getTime() - this.lastPickTime);
            this.lastPickTime = new Date().getTime();
          } else {
            this.totalFalse += 1;
            if (this.trueStack == 0) {
              this.level = Math.max(this.level - 1, 1);
            } else {
              this.trueStack -= 1;
            }
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/incorrect.mp3").play();
          }

          var ayni = _.random(0, 1) === 1;

          if (ayni) {
            this.currentStack.push({
              ...this.currentStack[_.random(0, 1)],
              id: _.random(68969949844),
              picked: false,
            });
            this.currentStack.splice(0, 1);
          } else {
            this.currentStack.splice(0, 1);
            this.currentStack.push(this.stack[0]);
          }
          this.currentStack[1].picked = true;
          this.stack.splice(0, 1);

          break;

        default:
          break;
      }
      setTimeout(() => {
        this.lock = false;
      }, 500);
    },
    next() {
      this.colors = {
        0: null,
        1: null,
      };
      this.options =
        this.levels[this.level - 1][
          _.random(0, this.levels[this.level - 1].length - 1)
        ];
      setTimeout(() => {
        this.lock = false;
      }, 400);
    },
  },
  watch: {
    trueStack: function (neww, old) {
      if (this.trueStack == 5 && old != 0) {
        this.level += 1;
      }
    },
    totalTrue: function () {
      $("#true").show();
      setTimeout(() => {
        $("#true").hide();
      }, 400);
    },
    totalFalse: function () {
      $("#false").show();
      setTimeout(() => {
        $("#false").hide();
      }, 400);
    },
  },
};
</script>

<style lang="less">
#goz_esnetme22 {
  width: 700px;
  max-width: 700px;
  height: 470px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background-image: url("/static/images/5630974.jpg") !important;
  flex-direction: column;
  background-size: cover;

  .flip-card {
    background-color: transparent;
    width: 200px;
    height: 200px;
    perspective: 1000px;
    transition: 1s;
    z-index: 2;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .flip-card.picked {
    //left: 325px;
    transition: 1s;
  }

  .flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
  }

  .flip-card.picked .flip-card-inner {
    transform: rotateY(-180deg);
    transform-origin: center;
  }

  .flip-card-front,
  .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden; /* Safari */
    backface-visibility: hidden;
    border-radius: 20px;
    border: 4px solid #ddd;
    text-align: center;
  }

  .flip-card-front {
    background-color: #fff;
    color: black;
    padding: 40px;
  }

  .flip-card-back {
    background-color: #fff;
    color: white;
    transform: rotateY(-180deg);
    background: url(/static/images/5670799.jpg);
    background-size: cover;
  }

  .list-complete-item {
    transition: all 1s;
    display: inline-block;
  }
  .list-complete-enter
/* .list-complete-leave-active below version 2.1.8 */ {
    transform: translateX(300px);
  }

  .list-complete-leave-to {
    transform: translateX(-300px) !important;
  }

  .list-complete-leave-active {
    position: absolute;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modules/HizliSecimTriple.vue